<template>
  <div class="vue-template">
    <Menu />
    <div class="inner-block-signup">
      <div class="vue-template">
        <form @submit.prevent="verify">
          <h3
            style="padding-top: 20px;"
            class="text-center headline purple--text text--darken-4"
          >{{ $t('SignUp.joinNowNow') }}</h3>

          <v-text-field
            v-model="user.email"
            class="p-0 mt-5"
            style="height:50px;"
            color="purple darken-4"
            outlined
            dense
          >
            <template v-slot:label>
              <span
                style="font-size: 0.875rem ;font-weight: 300;color: #282f37;"
              >{{ $t('SignUp.enterEmail') }}</span>
            </template>
          </v-text-field>

          <v-text-field
            v-model="user.password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            style="height:50px;"
            color="purple darken-4"
            class="p-0"
            outlined
            dense
            @click:append="show = !show"
          >
            <template v-slot:label>
              <span
                style="font-size: 0.875rem ;font-weight: 300;color: #282f37;"
              >{{ $t('SignUp.enterPassword') }}</span>
            </template>
          </v-text-field>

          <v-text-field
            v-model="user.passwordVerified"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            style="height:50px;"
            color="purple darken-4"
            outlined
            class="p-0"
            dense
            @click:append="show = !show"
          >
            <template v-slot:label>
              <span
                style="font-size: 0.875rem ;font-weight: 300;color: #282f37;"
              >{{ $t('SignUp.confirmPassword') }}</span>
            </template>
          </v-text-field>

          <div class="error-text">{{ error }}</div>

          <v-btn
            type="submit"
            style="outline: none;"
            block
            rounded
            color="font-weight-regular purple darken-4"
            dark
          >{{ $t('SignUp.btnSignUp') }}</v-btn>

          <div class="hr">
            <hr class="hr-separation" />
            <div class="hr-title body-1 purple--text text--darken-4">{{ $t('Login.Login.or') }}</div>
            <hr class="hr-separation" />
          </div>

          <SocialLinks />

          <p class="forgot-password text-right mt-2 mb-1">
            {{ $t('SignUp.alreadyRegister') }}
            <router-link
              :to="{name: 'login'}"
              class="purple--text text--darken-4"
            >{{ $t('SignUp.signIn') }}</router-link>
          </p>
        </form>
      </div>
    </div>
    <Footer :fixed="true" />
  </div>
</template>
<script>
import { auth, analytics } from "@/config/firebaseConfig";
import SocialLinks from "@/components/templates/SocialLinks";
import Menu from "@/components/templates/Menu";
import Footer from "@/components/templates/Footer";
import { addUserMGMDataBase } from "@/functions/MGM/dataBaseMGM";
export default {
  components: { SocialLinks, Menu, Footer },
  name: "SignUp",
  metaInfo() {
    return {
      title: this.$t("SignUp.metaTag.title"),
      meta: [
        { name: "description", content: this.$t("SignUp.metaTag.description") },
      ],
    };
  },
  data() {
    return {
      user: {
        email: "",
        password: "",
        passwordVerified: "",
      },
      error: "",
      show: false,
      userFather: this.$route.query.mgm || null,
      newUser: "",
    };
  },
  methods: {
    verify() {
      if (this.user.password == this.user.passwordVerified) {
        this.pressed();
      } else {
        this.error = this.$t("SignUp.metaTag.errorPassword");
      }
    },
    pressed() {
      auth
        .createUserWithEmailAndPassword(this.user.email, this.user.password)
        .then(this.sendEmailConfirmation())
        .catch((error) => (this.error = error.message));
    },
    sendEmailConfirmation() {
      auth.onAuthStateChanged((firebaseUSer) => {
        if (firebaseUSer) {
          if (!firebaseUSer.emailVerified) {
            firebaseUSer
              .sendEmailVerification()
              .then((this.newUser = firebaseUSer.uid))
              .then(this.replaceLogin)
              .catch((error) => (this.error = error.message));
          }
        }
      });
    },
    replaceLogin() {
      const message = this.$t("SignUp.messageSignUp");
      this.$store.commit("setMessage", message);
      this.$router.replace({ name: "login" });
      analytics.logEvent("Sig_Email");
      if (this.userFather != null) {
        this.mgmSendDataBase(this.newUser, this.userFather);
      }
    },
    async mgmSendDataBase(idSon, idFather) {
      await addUserMGMDataBase(idSon, idFather, false);
    },
  },
};
</script>
<style>
.inner-block-signup {
  width: 350px;
  margin: 150px auto 0px;
  background: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.08);
  padding: 0px 20px 15px 20px;
  border-radius: 15px;
  transition: all 0.3s;
}
.error {
  color: red;
  font-size: 18px;
}
.list-social {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ul-social {
  padding: 0px;
}
.hr {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0px;
  text-align: center;
  height: 0px;
  line-height: 0px;
}

.hr > hr {
  width: 170px;
  align-items: start;
  height: 1px;
}
.hr-title {
  padding: 5px;
  background-color: #ffffff;
  position: absolute;
  text-align: center;
}
@media (max-width: 500px) {
  .inner-block-signup {
    margin: 90px auto 0px;
    padding: 0px 10px 10px;
    width: 300px;
  }
}
</style>